import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconArrowTriangleBottom"><Path d="M4.18721 6.53463C3.61264 5.38775 4.42612 4 5.73462 4H18.2651C19.5736 4 20.3871 5.38775 19.8125 6.53463L13.5473 19.0404C12.9062 20.3199 11.0935 20.3199 10.4524 19.0404L4.18721 6.53463Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleBottom;
